import _ from 'lodash'
import moment from 'moment'

// test: jest src/models/__tests__/BookingPreset.model.spec.js
export default class BookingPreset {
  constructor(bookingPresetData) {
    this.bookingPresetData = bookingPresetData
  }

  static defaultValue() {
    return {
      name: null,
      type: "normal",
      status: "draft",
      start_at: moment().format('YYYY-MM-DD 00:00:00'),
      end_at: moment().format('YYYY-MM-DD 23:59:59'),
      config: {
        permissions: [],
        push_template:{
          header_bg_color : "",
          button_bg_color : ""
        },
        created_push_message: false,
        created_push_message_content: "",
        submit_button_text: "確認預約",
        every_day_message: "",
        daily_booking_reminder: [],
        welcome_page: {
          enable: false,
          banner_image: null,
          form_title: "",
          form_desc: "",
          content: "",
          button_text: "",
        },
        content_page: {
          displayed_in_every_page: false,
          banner_image: "",
          background_image: "",
          form_title: "",
          form_desc: "",
          content: "",
          submit_button_text: "送出",
        },
        schedule_page: {
          title: "",
        },
        confirm_page: {
          enable: true,
        },
        finished_page: {
          enabled_next_booking_button: true,
          enabled_go_booking_list_button: true,
          title: "預約成功！",
          content: "",
          banner_image: null,
          booking_person: [],
          booking_info: [],
          form_content: [],
          send_messages: {
            enabled: false,
            text: ""
          }
        },
        booking_tip: {
          form_title: "",
          form_desc: "",
          send_messages: {
            enabled: true,
            text: ""
          },
          button_top: {
            enabled: false,
            button_text: "",
            button_action: "",
            button_url: "",
          },
          button_bottom: {
            enabled: false,
            button_text: "",
            button_action: "",
            button_url: "",
          }
        },
        fields: [],
        description: null,
        booking_mapping: {
          bookings: {
            title: null,
            status: null,
            start_at: null,
            end_at: null,
            end_slot_minutes: 0,
            start_at_by_branch: null,
            closing_time: null,
          },
          default_status_value: null,
        },
        basic: {
          tips: "",
          lead_time: {
            type: "none",
            amount_day: "",
            amount_minute: ""
          },
          booking_window: {
            type: "none",
            amount_day: "",
            amount_minute: ""
          },
          duration_minutes: 0,
        },
        phone_verification: {
          timing: null,
          field_id: null
        },
        provider_config: {
          status_filter_mapping: [],
          booking_status_mapping: [],
        },
        liff_field_setting: {
          list: [],
        },
        event_setting: {
          booking_tags: [],
        },
        enabled_selected_staff: false,
        staff_role_filter: [],
        enabled_selected_staff_shift: false,
        enabled_staff_service_relation: false,
        enabled_selected_branch: false,
        display_branch_detail: true,
        branch_detail_mapping: [],
        display_branch_images: true,
        branch: {
          field_id: null
        },
        service: {
          collection_id: null,
          image_item_id: null,
          title_item_id: null,
          description_item_id: null,
          price_item_id: null,
          duration_item_id: null,
          can_multiple_select: false,
          service_field_id: null,
          should_auto_select_the_only_option: false,
        },
        order: {
          branch_page: 1,
          staff_page: 2,
          service_page: 3,
          schedule_page: 4,
          form_page: 5,
        },
        pages: [],
        sections: [],
        status_detector: [],
        liff_detail_inform_button: [],
        status_change_events: [],
        quotation_header: null,
        quotation_title: null,
        quotation_subTitle: null,
        quotation_content_header: [],
        quotation_content: [],
        quotation_content_footer: [],
        quotation_footer: null,
        buyer_business_number_id: "",
        buyer_company_name_id: "",
        can_edit_at_liff_mapping: [],
        occupy_config: {
          collection_field_id: null,
          collection_id: null,
          enable: false,
          full_alert_text: "該時段的預約數量已達上限",
          is_check_branch: false,
          is_check_collection: false,
          is_check_service: false,
          is_check_staff: false,
          occupy_status: [],
          limit_type: null,
          slot_people: 0
        },
        notify: {
          edit: {
            enabled: false,
          },
          cancel: {
            enabled: false,
            status_mapping: [],
          },
          confirmed: {
            enabled: false,
            status_mapping: [],
          },
          completed: {
            enabled: false,
            status_mapping: [],
          }
        },
        modified_push_message_content: "",
        canceled_push_message_content: "",
        confirmed_push_message_content: "",
        completed_push_message_content: "",
        created_push_header_image_url: "",
        canceled_push_header_image_url: "",
        modified_push_header_image_url: "",
        completed_push_header_image_url: "",
        confirmed_push_header_image_url: "",
        customer_staff: {
          enable: false,
          bound_type: ""
        },
        customer_branches: {
          enable: false,
          bound_type: ""
        },
        chatroom: {
          enable: false,
          is_auto: false,
          source_type: "booking",
          invite_booked_staff: false,
          invite_branches_staff: false,
          invite_branches_staff_by_roles: []
        },
        line_push: {
          staff_push: {
            enabled  : false,
            template : ""
          }
        },
        auto_change_status_enabled: false,
        auto_change_status_date_field_id: null,
        auto_change_status_overdue: [],
        auto_change_status_equal: [],
        display: {
          should_hide_end_time: false,
        },
      },
    }
  }

  requireCustomerRegistration() {
    return _.get(this.bookingPresetData, 'config.permissions', []).includes('registered')
  }

  get titleFieldAlias() {
    return _.get(this.bookingPresetData, "config.booking_mapping.bookings.title", null)
  }

  get statusFieldId() {
    return _.get(this.bookingPresetData, "config.booking_mapping.bookings.status", null)
  }

  get startAtFieldId() {
    return _.get(this.bookingPresetData, "config.booking_mapping.bookings.start_at", null)
  }

  get endAtFieldId() {
    return _.get(this.bookingPresetData, "config.booking_mapping.bookings.end_at", null)
  }

  get hasSetUpFieldMappingForStartAt() {
    return this.startAtFieldId !== null
  }

  get hasSetUpFieldMappingForEndAt() {
    return this.endAtFieldId !== null
  }

  get baseStartTimeField() {
    return _.get(this.bookingPresetData, 'config.fields', [])
      .find((field) => _.get(field, '_id') === this.startAtFieldId)
  }

  get branchStartTimeField() {
    return _.get(this.bookingPresetData, 'branch_config.fields', [])
      .find((field) => _.get(field, '_id') === this.startAtFieldId)
  }

  get startTimeField() {
    return this.branchStartTimeField || this.baseStartTimeField
  }

  get endTimeField() {
    return _.get(this.bookingPresetData, 'config.fields', [])
      .find((field) => _.get(field, '_id') === this.endAtFieldId)
  }

  get firstStartTimeOption() {
    return this.branchStartTimeField?.start_time || this.baseStartTimeField?.start_time
  }

  firstStartTimeOptionForWeekday(isoWeekday) {
    return this.earliestStartTimeOptionForWeekdayInBusinessHours(isoWeekday) ||
      this.branchStartTimeField?.start_time ||
      this.baseStartTimeField?.start_time
  }

  get lastStartTimeOption() {
    return this.branchStartTimeField?.end_time || this.baseStartTimeField?.end_time
  }

  lastStartTimeOptionForWeekday(isoWeekday) {
    return this.latestStartTimeOptionForWeekdayInBusinessHours(isoWeekday) ||
      this.branchStartTimeField?.end_time ||
      this.baseStartTimeField?.end_time
  }

  get timeOptionGap() {
    if (this.startTimeField?.time_condition === 'specified') {
      return this.endSlotMinutes
    }

    return Number(
      this.branchStartTimeField?.slot_minutes ||
      this.baseStartTimeField?.slot_minutes ||
      0
    )
  }

  get openingTime() {
    return this.firstStartTimeOption
  }

  // 商業邏輯：打烊時間
  get closingTimeDaily() {
    return this.closingTimeInBranchTimeField ?? this.closingTimeInBasicSetting ?? this.lastStartTimeOption
  }

  closingTimeForWeekday(isoWeekday) { // NOTE: according to ISO-8601, 1 is Monday, 7 is Sunday
    return this.closingTimeInBranchConfigForWeekday(isoWeekday) ??
      this.closingTimeInBranchTimeField ??
      this.closingTimeInBasicSetting ??
      this.lastStartTimeOption
  }

  get closingTimeInBranchTimeField() {
    return this.branchStartTimeField?.closing_time
  }

  get closingTimeInBasicSetting() {
    return _.get(this.bookingPresetData, 'config.booking_mapping.bookings.closing_time')
  }

  closingTimeInBranchConfigForWeekday(isoWeekday) { // NOTE: according to ISO-8601, 1 is Monday, 7 is Sunday
    return _.get(this.bookingPresetData, `branch_config.reservation_periods[${isoWeekday}].closing_time`)
  }

  businessHoursOfBranchConfig(isoWeekday) { // NOTE: according to ISO-8601, 1 is Monday, 7 is Sunday
    return _.get(this.bookingPresetData, `branch_config.reservation_periods[${isoWeekday}].business_hours`)
  }

  isOfficialHolidayOfBranch(isoWeekday) { // NOTE: according to ISO-8601, 1 is Monday, 7 is Sunday
    return _.get(this.bookingPresetData, `branch_config.reservation_periods[${isoWeekday}].is_official_holiday`, false) === true
  }

  targetTimeIsBetweenBusinessHours(targetTime) {
    const targetTimeMoment = moment(targetTime)
    const businessHours = this.businessHoursOfBranchConfig(targetTimeMoment.isoWeekday())
    if (businessHours === undefined) { // important for backward compatibility
      return true
    }

    if (businessHours.length === 0) {
      return false
    }

    return businessHours.some(businessHour => {
      const businessHoursStart = `${targetTimeMoment.format('YYYY-MM-DD')} ${businessHour.start_time}`
      const businessHoursEnd = `${targetTimeMoment.format('YYYY-MM-DD')} ${businessHour.end_time}`
      return targetTimeMoment.isBetween(businessHoursStart, businessHoursEnd) ||
        targetTimeMoment.isSame(businessHoursStart, 'second') ||
        targetTimeMoment.isSame(businessHoursEnd, 'second')
    })
  }

  earliestStartTimeOptionForWeekdayInBusinessHours(isoWeekday) {
    return _.minBy(this.businessHoursOfBranchConfig(isoWeekday) || [], 'start_time')?.start_time
  }

  latestStartTimeOptionForWeekdayInBusinessHours(isoWeekday) {
    return _.maxBy(this.businessHoursOfBranchConfig(isoWeekday) || [], 'end_time')?.end_time
  }

  get endSlotMinutes() {
    return Number(_.get(this.bookingPresetData, 'config.booking_mapping.bookings.end_slot_minutes', 0))
  }

  get endSlotMinutesIsAvailable() {
    return this.hasSetUpFieldMappingForEndAt &&
      this.endAtFieldId !== this.startAtFieldId &&
      _.get(this.endTimeField, 'format') === 'datetime'
  }

  get branchSelectionIsEnabled() {
    return _.get(this.bookingPresetData, 'config.enabled_selected_branch', false)
  }

  get staffSelectionIsEnabled() {
    return _.get(this.bookingPresetData, 'config.enabled_selected_staff', false)
  }

  get canSelectMultipleServices() {
    return _.get(this.bookingPresetData, "config.service.can_multiple_select", false)
  }

  get shouldAutoSelectTheOnlyService() {
    return _.get(this.bookingPresetData, "config.service.should_auto_select_the_only_option", false)
  }

  get startAtFieldFormatIsDate() {
    return this.startTimeField?.format === 'date'
  }

  get shouldHideEndTime() {
    return _.get(this.bookingPresetData, "config.display.should_hide_end_time", false)
  }

  get phoneVerificationTiming() {
    return _.get(this.bookingPresetData, 'config.phone_verification.timing', false)
  }

  get phoneVerificationFieldId() {
    return _.get(this.bookingPresetData, 'config.phone_verification.field_id', null)
  }

  get servicesAreRelatedToBranches() {
    const serviceField = _.get(this.bookingPresetData, 'config.fields', []).find(field =>
      field.type === 'collection_select' &&
      field._id === this.serviceFieldId
    )
    return !!serviceField?.branch_field_id
  }

  get servicesAreRelatedToStaffs() {
    return _.get(this.bookingPresetData, 'config.enabled_staff_service_relation', false)
  }

  get branchFieldId() {
    return _.get(this.bookingPresetData, 'config.branch.field_id')
  }

  get branchField() {
    return _.get(this.bookingPresetData, 'config.fields', [])
      .find((field) => field._id === this.branchFieldId)
  }

  get branchFieldIdForStartAtOptions() {
    return _.get(this.bookingPresetData, 'config.booking_mapping.bookings.start_at_by_branch')
  }

  get serviceFieldId() {
    return _.get(this.bookingPresetData, 'config.service.service_field_id')
  }

  get serviceField() {
    return _.get(this.bookingPresetData, 'config.fields', [])
      .find((field) => field._id === this.serviceFieldId)
  }

  get collectionIdForService() {
    return _.get(this.bookingPresetData, 'config.service.collection_id')
  }

  get isWizardMode() {
    return this.bookingPresetData?.type === "wizard"
  }

  get wizardFieldOrder() {
    const orderConfig = _.get(this.bookingPresetData, 'config.order', {})
    return {
      branch: orderConfig.branch_page || 1,
      staff: orderConfig.staff_page || 2,
      service: orderConfig.service_page || 3,
      schedule: orderConfig.schedule_page || 4,
      form: orderConfig.form_page || 5,
    }
  }

  get serviceFieldMappings() {
    return {
      title: _.get(this.bookingPresetData, 'config.service.title_item_id'),
      image: _.get(this.bookingPresetData, 'config.service.image_item_id'),
      description: _.get(this.bookingPresetData, 'config.service.description_item_id'),
      price: _.get(this.bookingPresetData, 'config.service.price_item_id'),
      duration: _.get(this.bookingPresetData, 'config.service.duration_item_id'),
    }
  }

  /**
   * 最大預約人數
   */
  get maximumBookingSlotCount() {
    if (_.get(this.bookingPresetData, 'config.occupy_config.limit_type') !== 'time') {
      return 0
    }
    return Number(_.get(this.bookingPresetData, 'config.occupy_config.slot_people', 0))
  }

  /*
   * Booking Window 預約時間限制: 限制使用者只能在某時間範圍內預約
   */
  get bookingWindowType() {
    return _.get(this.bookingPresetData, 'config.basic.booking_window.type') || 'none'
  }
  get bookingWindowDays() {
    return Number(_.get(this.bookingPresetData, 'config.basic.booking_window.amount_day') || 0)
  }
  get bookingWindowMinutes() {
    return Number(_.get(this.bookingPresetData, 'config.basic.booking_window.amount_minute') || 0)
  }

  /*
   * Lead Time 提前預約設定: 限制使用者必須提前多久預約
   */
  get leadTimeType() {
    return _.get(this.bookingPresetData, 'config.basic.lead_time.type') || 'none'
  }
  get leadTimeDays() {
    return Number(_.get(this.bookingPresetData, 'config.basic.lead_time.amount_day') || 0)
  }
  get leadTimeMinutes() {
    return Number(_.get(this.bookingPresetData, 'config.basic.lead_time.amount_minute') || 0)
  }

  /*
   * booking window 限制使用者只能在某時間範圍內預約，lead time 限制使用者必須提前多久預約
   * 因此 booking window 不能小於 lead time，否則使用者完全無法預約
   * 此 function 回傳 false 即代表目前的設定違反此規則
   */
  bookingWindowIsGreaterThanLeadTime() {
    if ([this.bookingWindowType, this.leadTimeType].includes('none')) {
      return true
    }

    const bookingWindowMoment = moment()
    const leadTimeMoment = bookingWindowMoment.clone()

    if (this.bookingWindowType === 'day') {
      bookingWindowMoment.add(this.bookingWindowDays, 'days')
    } else if (this.bookingWindowType === 'minute') {
      bookingWindowMoment.add(this.bookingWindowMinutes, 'minutes')
    }

    if (this.leadTimeType === 'day') {
      leadTimeMoment.add(this.leadTimeDays, 'days')
    } else if (this.leadTimeType === 'minute') {
      leadTimeMoment.add(this.leadTimeMinutes, 'minutes')
    }

    return bookingWindowMoment.isAfter(leadTimeMoment)
  }

  validateNormalConfiguration() {
    const errors = {
      "目前的欄位設定不允許設定預留時間區段": () => !this.endSlotMinutesIsAvailable && this.endSlotMinutes > 0,
    }

    const errorMessages = Object.keys(errors).filter(key => errors[key]()).map(key => key)

    if (errorMessages.length > 0) {
      const exception = new Error()
      exception.messages = errorMessages
      throw exception
    }
  }

  validateWizardConfiguration() {
    const errors = {
      "尚未設定預約開始欄位": () => false === this.hasSetUpFieldMappingForStartAt,
      "分店設定不同": () => this.branchFieldIdForStartAtOptions !== this.branchFieldId,
      "未啟用分店": () => this.branchFieldIdForStartAtOptions && false === this.branchSelectionIsEnabled,
      "未啟用服務": () => !this.serviceFieldId,
    }

    const errorMessages = Object.keys(errors).filter(key => errors[key]()).map(key => key)

    if (errorMessages.length > 0) {
      const exception = new Error()
      exception.messages = errorMessages
      throw exception
    }
  }

  get wizardSteps() {
    return [
      { name: "LiffReservation", enabled: true, order: 0 },
      { name: "LiffReservationBranch", enabled: this.branchSelectionIsEnabled, order: this.wizardFieldOrder.branch },
      { name: "LiffReservationStaff", enabled: this.staffSelectionIsEnabled, order: this.wizardFieldOrder.staff },
      { name: "LiffReservationService", enabled: !!this.collectionIdForService, order: this.wizardFieldOrder.service },
      { name: "LiffReservationSchedule", enabled: true, order: this.wizardFieldOrder.schedule },
      { name: "LiffReservationForm", enabled: true, order: this.wizardFieldOrder.form },
      { name: "LiffReservationConfirm", enabled: _.get(this.bookingPresetData, 'config.confirm_page.enable', true), order: 6 },
      { name: "LiffReservationSuccess", enabled: true, order: 7 },
    ].filter((step) => step.enabled).sort((a, b) => a.order - b.order)
  }

  previousWizardStep(currentStepName) {
    const currentStep = this.wizardSteps.find(step => step.name === currentStepName)
    if (!currentStep) {
      return undefined
    }
    const prevStep = _.findLast(this.wizardSteps, step => step.order < currentStep.order && !!step.enabled)
    return prevStep?.order > 0 ? prevStep.name : undefined
  }

  nextWizardStep(currentStepName) {
    const currentStep = this.wizardSteps.find(step => step.name === currentStepName)
    if (!currentStep) {
      return undefined
    }
    const nextStep = this.wizardSteps.find(step => step.order > currentStep.order && !!step.enabled)
    return nextStep?.name
  }

  /**
   * @param {DynamicFormField} fieldModel
   * @returns {boolean}
   */
  customerVisibleFieldsInWizard(fieldModel) {
    const hiddenFields = [
      this.startAtFieldId,
      this.branchFieldId,
      this.serviceFieldId,
    ]

    return !fieldModel.dashboard_only && !hiddenFields.includes(fieldModel._id)
  }

  /*
   * 定義各種文案的預設值
   * 註：此區一般來說沒有寫單元測試的價值
   */
  get submitButtonText() {
    return _.get(this.bookingPresetData, 'config.submit_button_text', '確認預約')
  }
}
